import React, { Component } from 'react';
import {DOCUMENTATION_MAP} from './constants.js';

class DocumentationSidebar extends Component {
    getClassName(name) {
        return this.props.toShow === name ?
            'topic selected': 'topic';
    }

    render() {
        return (
            <div className="doc-sidebar">
              {Object.keys(DOCUMENTATION_MAP).map(
                  name =>
                      <div
                        onClick={() => this.props.onClick(name)}
                            className={this.getClassName(name)}>{name}</div>)}
                           
            </div>
        );
    }
}

export default DocumentationSidebar;
